import mailMessageApi from '@/api/mailMessage';
import { loadEntity, loadPaginatedEntity } from '@/helpers/utility';

const state = {
    byId: {},
    currentPage: null,
    totalPages: null,
    currentPageIds: null,
};

const getters = {
    currentPageMailMessages(state) {
        if (state.currentPageIds)
            return state.currentPageIds.map(id => state.byId[id]);
    },
};

const actions = {
    async getMailMessages({ commit }, { page }) {
        let pagedMailMessages = await mailMessageApi.list({ page });
        loadPaginatedEntity('mailMessages', pagedMailMessages);
    },
    async getMailMessage(store, { id }) {
        let mailMessage = await mailMessageApi.get(id);
        loadEntity({ mailMessage });
        return mailMessage;
    },
    async mailMessageReceived({ state, dispatch, commit }, { mailMessageId }) {
        let mailMessage = await dispatch('getMailMessage', { id: mailMessageId });

        if (state.currentPage === 1)
            commit('ADD_MAILMESSAGE_TO_CURRENT_PAGE', { mailMessage });
    },
    subscribe({ dispatch }, { channels }) {
        if (channels.indexOf('mail') === -1)
            return;

        Echo.leave('mail');

        Echo.private('mail')
            .listen('Mail.MailMessageReceived', (e) => dispatch('mailMessageReceived', { mailMessageId: e.mailMessageId }));
    },
    unsubscribe(store, { channels }) {
        if (channels.indexOf('mail') === -1)
            return;

        Echo.leave('mail');
    },
};

const mutations = {
    LOAD_ENTITIES(state, { mailMessages, meta }) {
        if (mailMessages)
            Object.values(mailMessages).forEach(mailMessage => state.byId[mailMessage.id] = mailMessage);

        if (meta && meta.type === 'mailMessages' && meta.paginated) {
            state.currentPage = meta.currentPage;
            state.totalPages = meta.totalPages;
            state.currentPageIds = meta.ids;
        }
    },
    ADD_MAILMESSAGE_TO_CURRENT_PAGE(state, { mailMessage }) {
        if (state.currentPageIds)
            state.currentPageIds.unshift(mailMessage.id);
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
